export const SAVE_SETTINGS = 'DATASET_SAVE_SETTINGS';

// Import dataset action types
export const CREATE = 'DATASET_CREATE';
export const SELECT_DATA_SOURCE = 'DATASET_SELECT_DATA_SOURCE';
export const NEXT_PAGE = 'DATASET_IMPORT_NEXT_PAGE';
export const PREVIOUS_PAGE = 'DATASET_IMPORT_PREVIOUS_PAGE';
export const UPDATE_UPLOAD_STATUS = 'DATASET_UPDATE_UPLOAD_STATUS';
export const DEFINE_DATA_SOURCE = 'DATASET_DEFINE_DATA_SOURCE';
export const DEFINE_DATASET_SETTINGS = 'DATASET_DEFINE_SETTINGS';
export const CLEAR_IMPORT = 'DATASET_CLEAR_IMPORT';

export const FETCH_DATASET_REQUEST = 'DATASET_FETCH_REQUEST';
export const FETCH_DATASET_SUCCESS = 'DATASET_FETCH_SUCCESS';
export const FETCH_DATASET_FAILURE = 'DATASET_FETCH_FAILURE';

export const FETCH_COLUMN_DATASET_REQUEST = 'DATASET_COLUMN_FETCH_REQUEST';
export const FETCH_COLUMN_DATASET_SUCCESS = 'DATASET_COLUMN_FETCH_SUCCESS';
export const FETCH_COLUMN_DATASET_FAILURE = 'DATASET_COLUMN_FETCH_FAILURE';


export const FETCH_SORTED_DATASET_REQUEST = 'SORTED_DATASET_FETCH_REQUEST';
export const FETCH_SORTED_DATASET_SUCCESS = 'SORTED_DATASET_FETCH_SUCCESS';
export const FETCH_SORTED_DATASET_FAILURE = 'SORTED_DATASET_FETCH_FAILURE';

export const IMPORT_DATASET_REQUEST = 'DATASET_IMPORT_REQUEST';
export const IMPORT_DATASET_PENDING = 'DATASET_IMPORT_PENDING';
export const IMPORT_DATASET_SUCCESS = 'DATASET_IMPORT_SUCCESS';
export const IMPORT_DATASET_FAILURE = 'DATASET_IMPORT_FAILURE';

export const FETCH_DATASETS_SUCCESS = 'DATASETS_FETCH_SUCCESS';

export const TOGGLE_DATASET_UPDATE_PENDING = 'DATASET_TOGGLE_UPDATE_PENDING';

// Delete dataset
export const DELETE_DATASET_REQUEST = 'DATASET_DELETE_REQUEST';
export const DELETE_DATASET_FAILURE = 'DATASET_DELETE_FAILURE';
export const DELETE_DATASET_SUCCESS = 'DATASET_DELETE_SUCCESS';
export const REMOVE_DATASET = 'DATASET_REMOVE';

// Update dataset meta - eg. title
export const UPDATE_DATASET_META_REQUEST = 'DATASET_UPDATE_META_REQUEST';
export const UPDATE_DATASET_META_SUCCESS = 'DATASET_UPDATE_META_SUCCESS';
export const UPDATE_DATASET_META_FAILURE = 'DATASET_UPDATE_META_FAILURE';

// Transformations
export const REPLACE_DATASET = 'REPLACE_DATASET';
export const TRANSFORMATION_LOG_REQUEST_SENT = 'DATASET_TRANSFORMATION_LOG_REQUEST_SENT';
export const TRANSFORMATION_DATASET_PENDING = 'DATASET_TRANSFORMATION_PENDING';
export const TRANSFORMATION_FAILURE = 'DATASET_TRANSFORMATION_FAILURE';
export const TRANSFORMATION_SUCCESS = 'DATASET_TRANSFORMATION_SUCCESS';
export const UNDO_TRANSFORMATION = 'DATASET_UNDO_TRANSFORMATION';

export const POLL_INTERVAL = 1000;

export const TRANSFORMATION_START = 'TRANSFORMATION_START';
export const TRANSFORMATION_END = 'TRANSFORMATION_END';



// WEBPACK FOOTER //
// ./src/constants/dataset.js